import {
  useActions as useLoadActions,
  selectors as loadSelectors,
} from '../../store/Reports/CashbacksDataSlice';

const useCashbacksData = () => {
  const { load: loadCashbacksData } = useLoadActions();
  const { getData, getLoadingState } = loadSelectors;
  const cashbacksData = getData();
  const cashbacksDataLoadingState = getLoadingState();

  return {
    cashbacksData,
    loadCashbacksData,
    cashbacksDataLoadingState,
  };
};

export default useCashbacksData;
